
export function TagTableMoveUpClicked(visibleIndex) {

    if (visibleIndex === 0) {
        return;
    }
    // azért nem írtuk ki a típusát, mert még nincs benne abban a dx verzióban a performcallback hívás ami objectet is tud kezelni :(
    let grid = window["TagList"];

    var rowKey = grid.GetRowKey(visibleIndex);
    var previousRowKey = grid.GetRowKey(visibleIndex - 1);

    grid.PerformCallback({
        command: "SWAPROWS",
        row1: rowKey,
        row2: previousRowKey,
        increment: false
    });
}

export function TagTableMoveDownClicked(visibleIndex) {
    // azért nem írtuk ki a típusát, mert még nincs benne abban a dx verzióban a performcallback hívás ami objectet is tud kezelni :(
    let grid = window["TagList"];
    if (visibleIndex === grid.VisibleRowCount - 1) {
        return;
    }

    var rowKey = grid.GetRowKey(visibleIndex);
    var nextRowKey = grid.GetRowKey(visibleIndex + 1);

    grid.PerformCallback({
        command: "SWAPROWS",
        row1: rowKey,
        row2: nextRowKey,
        increment: true
    });
}
